module.exports = __webpack_public_path__ + "static/img/LK@3x.4a600e38.png";